import React, {FC, memo} from 'react';
import {useTranslations} from '@montana/containers/translations';
import {ProductImage} from '../product-image/product-image.component';
import {IPrice} from '@montana/models/generated/cms.interface';
import {Link} from '../link';
import {useTracking} from '@montana/containers/tracking';
import {IGtmProductFromList} from '@montana/services/tracking/tracking';

interface IProductCardProfessionalProps {
    className?: string;
    title?: string;
    fromPrice?: IPrice;
    description?: string;
    downloadSheet?: string;
    download3DFile?: string;
    moreInformation?: string;
    imageUrl?: string;
    gtmProduct?: IGtmProductFromList;
}

export const ProductCardProfessional: FC<IProductCardProfessionalProps> = memo((props: IProductCardProfessionalProps) => {
    const {
        className,
        title,
        fromPrice,
        description,
        downloadSheet,
        download3DFile,
        moreInformation,
        imageUrl,
        gtmProduct,
    } = props;

    const translate = useTranslations();
    const {trackProductClick} = useTracking();

    const onClick = () => {
        if (gtmProduct) {
            trackProductClick(fromPrice?.currency || '', gtmProduct, 'category');
        }
    };

    return (
        <div>
            <Link
                className={`product-card-professional${className ? ` ${className}` : ''}`}
                to={moreInformation}
                title={title}
                onClick={onClick}
            >
                <div className={'product-card__image-wrapper'}>
                    <ProductImage
                        url={imageUrl}
                        ariaHidden={true}
                        name={title}
                    />

                </div>
            </Link>
            <div className="product-card-professional__information">
                <div className="product-card-professional__information-row">
                    <h3 className="product-card-professional__information-heading">{title}</h3>
                    {!!fromPrice && (
                        <p className="product-card-professional__information-price">
                            {translate((t): string => t.productPage.professionalsProductPageFrom, "[From]")} {fromPrice.formattedWithCurrency}
                        </p>
                    )}
                </div>
                {!!description &&
                    <div className="product-card-professional__information-row">
                        <p className="product-card-professional__information-specs">
                            {description}
                        </p>
                    </div>
                }
                {downloadSheet &&
                    <a className="product-card-professional__information-row-download" href={downloadSheet}
                       target="_blank" rel="noreferrer">
                        <p className="product-card-professional__information-specs">
                            {translate((t): string => t.filterAndSearch.productsheet, "[Productsheet]")}
                        </p>
                        <img src={`/assets/icons/download.svg`} width={16}></img>
                    </a>
                }
                {download3DFile &&
                    <a className="product-card-professional__information-row-download" href={download3DFile}
                       target="_blank" rel="noreferrer">
                        <p className="product-card-professional__information-specs">
                            {translate((t): string => t.filterAndSearch.files3D, "[3D files]")}
                        </p>
                        <img src={`/assets/icons/download.svg`} width={16}></img>
                    </a>
                }
                <Link
                    className='product-card-professional__information-link'
                    to={moreInformation}
                    title="More information"
                >
                    {translate((t): string => t.filterAndSearch.moreInformation, "[More information]")}
                </Link>
            </div>
        </div>
    )
});
